export default __webpack_public_path__ + "static/media/flip_vertical.640c1376.svg";